// Brand mark: a house with a check, plus the wordmark
const LogoMark = ({ className = "w-9 h-9" }) => (
  <svg className={className} viewBox="0 0 40 40" fill="none" aria-hidden="true">
    <defs>
      <linearGradient id="ctiMark" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
        <stop stopColor="#fbbf24" />
        <stop offset="1" stopColor="#d97706" />
      </linearGradient>
    </defs>
    <rect width="40" height="40" rx="10" fill="url(#ctiMark)" />
    <path d="M9 19.5 20 10l11 9.5" stroke="#fffbeb" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12.5 17v12.5h15V17" stroke="#fff" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="m16 23.2 3 3 5.2-5.6" stroke="#fffbeb" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const Logo = ({ subtitle, size = "md", onClick, light = false }) => {
  const big = size === "lg";
  const Wrapper = onClick ? "button" : "div";
  return (
    <Wrapper type={onClick ? "button" : undefined} onClick={onClick} className="flex items-center gap-3 min-w-0 text-left">
      <LogoMark className={`${big ? "w-12 h-12" : "w-9 h-9 sm:w-10 sm:h-10"} flex-shrink-0 ${light ? "rounded-[10px] ring-2 ring-white/50 shadow-lg" : ""}`} />
      <div className="min-w-0 leading-tight">
        <span className={`block font-extrabold tracking-tight ${light ? "text-white" : "text-amber-900"} truncate ${big ? "text-2xl sm:text-3xl" : "text-lg sm:text-xl"}`}>
          Conoce tu <span className={light ? "text-amber-100" : "text-amber-700"}>Inquilino</span>
        </span>
        {subtitle && <span className={`block text-xs sm:text-sm ${light ? "text-amber-100" : "text-amber-700/80"} font-medium truncate`}>{subtitle}</span>}
      </div>
    </Wrapper>
  );
};

export { Logo, LogoMark };
